import { Spinner } from 'spin.js';

$(function () {
  let isPmpSettingsChanged = false;
  const stateModal = $('#state-remove-confirm');
  const stateApprovalTable = $('#state-approval-table');
  const accountId = $('#account-id').attr('data-id');
  let stateCode;
  let stateModalBootstrap;

  if (stateModal.length > 0) {
    stateModalBootstrap = new bootstrap.Modal(stateModal);

    $('.pmps-cancel-modal button.submit').on('click', function () {
      stateModalBootstrap.hide();
      stateCode = stateModal.attr('data-state');
      const stateTableData = stateApprovalTable.find('tr[data-state=' + stateCode + ']');
      toggleStateWebRequest(stateTableData, stateCode);
      stateTableData.find("input:checkbox").prop("checked", false)
    });
  }

  if (accountId != undefined) {
    bindEvent(window, "state-approval", function (e) {
      stateCode = e.detail.additional_info;
      const approvalTableData = stateApprovalTable.find("tr[data-state='" + stateCode + "']").find('.state-approval');
      let textStyle, statusMessage;

      if (e.detail.status_type == 'success') {
        statusMessage = 'Approved';
        textStyle = 'text-success';
      } else if (e.detail.status_type == 'error') {
        statusMessage = 'Rejected';
        textStyle = 'text-error';
      }
      approvalTableData.find('strong').text(statusMessage).addClass(textStyle);
    });

    /**
     * Handle State select box toggles. Send out a request to toggle approval
     */
    $('.state-checkbox').on('click', function (e) {
      const stateTableData = $(this).closest('tr');
      stateCode = stateTableData.attr('data-state');
      //The icon check icon is changed before this event is fired so this check seems backwards but actually right.
      if (!$(this).is(':checked')) { //Signals disapproval. Prompt confirmation.
        e.preventDefault();
        if (stateModalBootstrap) {
          stateModalBootstrap.show();
          stateModal.attr('data-state', stateCode);
        }
      } else {
        toggleStateWebRequest(stateTableData, stateCode);
      }
    });
  }

  function bindEvent(el, eventName, eventHandler) {
    if (el.addEventListener) {
      el.addEventListener(eventName, eventHandler, false);
    } else if (el.attachEvent) {
      el.attachEvent('on' + eventName, eventHandler);
    }
  }

  function toggleStateWebRequest(stateTableData, stateCode) {
    let statusField = stateTableData.find('.state-approval');
    const spinner = new Spinner({ radius: 4, width: 2 }).spin();
    spinner.el.setAttribute('aria-label', 'Loading');
    let message;
    statusField.prepend(spinner.el);
    $.get("/pmp_account_links/request_approval_toggle", { state_cd: stateCode })
      .done(function (data) {
        message = JSON.parse(data);
        handleApprovalResponse(message, statusField, spinner);
      })
      .fail(function () {
        message = { error: 'Unable to make request. Contact support.' };
        handleApprovalResponse(message, statusField, spinner);
      });
  }

  function handleApprovalResponse(message, statusField, spinner) {
    if (message.success != undefined) {
      updateStateRequestStatus(message, statusField, spinner);
    } else {
      statusField.text(message.error).addClass('text-error');
      stopStateApproveSpinner(spinner);
    }
  }

  function stopStateApproveSpinner(spinner) {
    if (spinner != undefined && spinner != null) {
      spinner.stop();
    }
  }

  function updateStateRequestStatus(message, statusField, spinner) {
    setTimeout(function () {
      if (spinner != undefined && spinner != null) {
        spinner.stop();
      }
      statusField.html(statusFieldRender(message.success));
      if (!isPmpSettingsChanged) {
        $("#auto-saved-text").fadeIn();
        isPmpSettingsChanged = true;
      }
    }, 500);
  }

  function statusFieldRender(msg) {
    return "<span class=text-" +
      (msg === 'Approved' ? 'success' : 'warning') +
      "><strong>" +
      msg +
      "</strong></span>";
  }
})